import { render } from "./ContactEdit.vue?vue&type=template&id=552ac51a&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=js"
export * from "./ContactEdit.vue?vue&type=script&lang=js"

import "./ContactEdit.vue?vue&type=style&index=0&id=552ac51a&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552ac51a"]])

export default __exports__